import { render, staticRenderFns } from "./ColorLegend.vue?vue&type=template&id=4cbf516c"
import script from "./ColorLegend.vue?vue&type=script&lang=ts"
export * from "./ColorLegend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports